<script>
    import AppMixin from 'keysso/mixins/AppMixin'
    import {Listeners} from "keysso/constants/listeners";
    import AdaptersDialog from "keysso/component/adapters/Dialog.vue";
    import {store} from "../store";
    import AdaptersMessage from "keysso/component/adapters/Message.vue";
    import RadioButton from "primevue/radiobutton";
    import Slider from "primevue/slider";
    import Checkbox from "primevue/checkbox";
    import InputNumber from "primevue/inputnumber";
    import Button from "primevue/button";
    import ClusterApi from "keysso/api/ClusterApi";
    import Alerts from "keysso/mixins/Alerts";
    import TariffAPI from "keysso/api/TariffAPI";
    import {FormatHelper} from "keysso/helpers/FormatHelper";
    import {DataTransformer} from "keysso/page/monitoring/DataTransformer";
    import ClusteringSelectRegion from "./SelectRegion.vue";
    import {ProjectsConstants} from "../../wordstat/constants/projectConstants";
    import _ from "lodash";

    export default {
        mixins: [AppMixin, Alerts],
        props: {
            isDemo: {
                type: Boolean,
                required: false,
                default: false,
            },
            monitoring: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                name:"AutoCluster",
                loading: false,
                error: null,
                limitLoaded: false,
                limits: {
                    wordstatPerMonth: 0,
                    serpProjectsKeysPerMonth: 0,
                    topNumberFactorRelations: {}
                },
                unknownWs: 0,
                unknownSerp: 0,
                unknownTotal: 0,
                totalKeys: 0,
                isNeedAttention: false,
                model: {
                    topNumber: 10,
                    fStrength: 50,
                    fIsWsk: false,
                    fWsk: 100,
                    fIsSumWsk: false,
                    fSumWsk: 300,
                    /**
                     * Возможные значения: 'ignore'|'unknown'|'all'
                     */
                    updateTypePhrases: 'ignore',
                    /**
                     * Обновление выдачи, создание serp проекта
                     */
                    isSerpProject: true,
                    /**
                     * Обновление частотки, создание wordstat проекта
                     */
                    isWsProject: true,
                    monitoringProject: {},
                    frequency: {
                        [ProjectsConstants.FREQUENCY_TYPE_WS]: true,
                        [ProjectsConstants.FREQUENCY_TYPE_WSK]: false,
                        [ProjectsConstants.FREQUENCY_TYPE_SWSK]: false,
                    },
                },
                store: store,
                searchSettings: [],
            }
        },
        mounted() {
            if (this.monitoring.isMonitoringProject) {
                this.searchSettings = DataTransformer.searchFromRequest(this.monitoring.regions);
                const targetRegion = Object.keys(this.monitoring.current).length
                    ? this.monitoring.current
                    : this.monitoring.regions[0];
                this.model.monitoringProject = DataTransformer.searchSingleFromRequest(targetRegion);
            }
        },
        methods: {
            doAutoCluster() {
                if (this.isDisabledStartByLimits) {
                    this.alertError(this.$t('lang.cluster.update_parser_limits_error'));
                    return;
                }
                if (this.isDemo) {
                    this.alertError(this.$t('lang.cluster.auto_cls_demo_block'));
                    return;
                }

                let payload = _.clone(this.model);
                if (this.monitoring.isMonitoringProject) {
                    Object.assign(payload, {project: DataTransformer.searchSingleForRequestFormat(payload.monitoringProject)});
                }

                payload.ws_types = this.getFrequency;

                delete payload.monitoringProject;
                delete payload.frequency;

                this.loading = true;
                ClusterApi
                    .doAutoCluster(this.getUid, payload)
                    .then(() => window.location.reload())
                    .catch(error => this.alertError(error.message))
                    .finally(() => this.loading = false);
            },
            getUnknownKeys() {
                this.loading = true;
                ClusterApi
                    .getUnknownKeys(this.getUid)
                    .then(response => {
                        this.unknownWs = response.unknownWs;
                        this.unknownSerp = response.unknownSerp;
                        this.unknownTotal = response.unknownTotal;
                        this.totalKeys = response.totalKeys;
                        this.isNeedAttention = response.isNeedAttention;
                        this.model.updateTypePhrases = this.unknownTotal > 0 ? 'unknown' : 'ignore';
                    })
                    .catch(error => this.alertError(error.message))
                    .finally(() => this.loading = false);
            },
            onClose(){
                this.error = null;
                this.$emitter.emit(this.getListenerCloseId);
            },
            onOpen(){
                this.getLimits();
                this.getUnknownKeys();
                this.$emitter.emit(this.getListenerId);
            },
            getLimits() {
                if (!this.loadedLimit) {
                    this.loading = true;
                    TariffAPI
                        .getLimits()
                        .then(response => {
                            this.limits.wordstatPerMonth = response.wordstat.perMonth;
                            this.limits.serpProjectsKeysPerMonth = response.serpProjectsKeys.perMonth;
                            this.limits.topNumberFactorRelations = response.serpProjectsKeys.topNumberFactorRelations;
                            this.loadedLimit = true;
                        })
                        .finally(() => this.loading = false);
                }
            },
        },
        computed: {
            ProjectsConstants() {
                return ProjectsConstants
            },
            getUid() {
                return this.store.getters.uid();
            },
            getListenerId() {
                return Listeners.AUTO_CLUSTER_POPUP_OPEN;
            },
            getListenerCloseId() {
                return Listeners.AUTO_CLUSTER_POPUP_CLOSE;
            },
            isDisabledStartByLimits() {
                return this.isUpdateTypePhrasesSelected && (
                    (this.model.isWsProject && this.getLimitsUpdateWs > this.getLimitWs)
                    || (this.model.isSerpProject && this.getLimitsUpdateSerp > this.getLimitSerp)
                );
            },
            getLimitsUpdateWs() {
                let words = 0;
                if (this.model.updateTypePhrases === 'unknown') {
                    words = this.unknownWs;
                } else if (this.model.updateTypePhrases === 'all') {
                    words = this.totalKeys;
                }

                return words * this.getFrequency.length;
            },
            getFrequency() {
                return Object.keys(this.model.frequency).filter(key => this.model.frequency[key]).map(Number);
            },
            getLimitsUpdateWsHtml() {
                const formattedValue = FormatHelper.numberWithZero(this.getLimitsUpdateWs);
                if (this.getLimitsUpdateWs > this.getLimitWs) {
                    return '<b class="text-red-500">' + formattedValue + '</b>';
                } else {
                    return '<b>' + formattedValue + '</b>';
                }
            },
            getLimitsUpdateSerp() {
                if (this.model.updateTypePhrases === 'unknown') {
                    return this.unknownSerp * this.getTariffSerpFactor;
                } else if (this.model.updateTypePhrases === 'all') {
                    return this.totalKeys * this.getTariffSerpFactor;
                }
            },
            getLimitsUpdateSerpHtml() {
                const formattedValue = FormatHelper.numberWithZero(this.getLimitsUpdateSerp);
                if (this.getLimitsUpdateSerp > this.getLimitSerp) {
                    return '<b class="text-red-500">' + formattedValue + '</b>';
                } else {
                    return '<b>' + formattedValue + '</b>';
                }
            },
            getLimitsUpdateHtml() {
                if (!this.isUpdateTypePhrasesSelected || (!this.model.isWsProject && !this.model.isSerpProject)) {
                    return '';
                }

                /**
                 * Формируем части строки лимитов, в зависимости от выбранных пунктов
                 */
                let limitParts = [];
                if (this.model.isWsProject) {
                    limitParts.push(
                        this.$t('lang.cluster.update_parser_limits_ws_part', [
                            this.getLimitsUpdateWsHtml,
                            FormatHelper.numberWithZero(this.getLimitWs)
                        ])
                    );
                }
                if (this.model.isSerpProject) {
                    limitParts.push(
                        this.$t('lang.cluster.update_parser_limits_serp_part', [
                            this.getLimitsUpdateSerpHtml,
                            FormatHelper.numberWithZero(this.getLimitSerp)
                        ])
                    );
                }

                return this.$t('lang.cluster.update_parser_limits', [limitParts.join(' и ')]);
            },
            getTariffSerpFactor() {
                return this.limits.topNumberFactorRelations[this.model.topNumber];
            },
            getLimitWs() {
                return this.limits.wordstatPerMonth.limit - this.limits.wordstatPerMonth.usedLimit;
            },
            getLimitSerp() {
                return this.limits.serpProjectsKeysPerMonth.limit - this.limits.serpProjectsKeysPerMonth.usedLimit;
            },
            isUpdateTypePhrasesSelected() {
                return this.model.updateTypePhrases === 'unknown' || this.model.updateTypePhrases === 'all';
            }
        },
        watch: {
            'model.topNumber'() {
                if (this.isUpdateTypePhrasesSelected && this.model.isSerpProject) {
                    this.alertInfo(this.$t('lang.cluster.change_top_number_info'));
                }
            }
        },
        components: {
            ClusteringSelectRegion,
            AdaptersDialog,
            AdaptersMessage,
            RadioButton,
            Slider,
            Checkbox,
            InputNumber,
            Button,
        },
    }
</script>
<template>
    <div>
        <Button
            @click="onOpen"
            :label="$t('lang.cluster.auto_cls')"
            :title="$t('lang.cluster.auto_cls_title')"
            size="small"
            icon="fa fa-magic"
            id="tour-step-9"
            class="flex w-full sm:w-auto"
            :pt="{
                icon: { class: 'hidden sm:block' }
            }"
        />
        <AdaptersDialog
            :listener-id="getListenerId"
            :listener-close-id="getListenerCloseId"
            :header="$t('lang.cluster.auto_cls_setting')"
            :loading="loading"
            :error-message="error"
            :callback-agree="doAutoCluster"
            :button-agree-label="$t('lang.main.btn.run')"
            :callback-on-hide="onClose"
            :is-disable-send="isDisabledStartByLimits || isDemo"
        >
            <template #content>
                <AdaptersMessage v-if="isDemo" severity="error" :message="$t('lang.cluster.auto_cls_demo_block')" />
                <ClusteringSelectRegion v-if="monitoring.isMonitoringProject" v-model="model.monitoringProject" :searchSettings="searchSettings" />
                <div v-else>
                    <AdaptersMessage v-if="unknownTotal > 0" severity="info" :message="$t('lang.cluster.auto_cls_unk_key', [unknownTotal])" />
                    <div class="formgroup-inline">
                        <label>{{ $t('lang.cluster.update_ws_serp_label') }}</label>
                        <div class="field-radiobutton" :class="{'p-disabled': !unknownTotal}">
                            <RadioButton
                                v-model="model.updateTypePhrases"
                                inputId="updateUnknown"
                                name="updateTypePhrases"
                                value="unknown"
                                :disabled="!unknownTotal"
                            />
                            <label for="updateUnknown">{{ $t('lang.cluster.update_parser_unknown_label') }}</label>
                            <i
                                class="pi pi-question-circle ml-2 cursor-pointer text-color-secondary update-unknown-help"
                                v-tooltip.top="{ value: $t('lang.cluster.update_parser_unknown_help'), id: 'ks-auto-cluster-unknown-tooltip' }"
                            ></i>
                        </div>
                        <div class="field-radiobutton">
                            <RadioButton
                                v-model="model.updateTypePhrases"
                                inputId="updateAll"
                                name="updateTypePhrases"
                                value="all"
                            />
                            <label for="updateAll">{{ $t('lang.cluster.update_parser_all_label') }}</label>
                        </div>
                        <div class="field-radiobutton">
                            <RadioButton
                                v-model="model.updateTypePhrases"
                                inputId="updateIgnore"
                                name="updateTypePhrases"
                                value="ignore"
                            />
                            <label for="updateIgnore">{{ $t('lang.cluster.update_parser_ignore_label') }}</label>
                        </div>
                    </div>
                    <template v-if="isUpdateTypePhrasesSelected">
                        <div class="formgroup-inline">
                            <div class="field-checkbox">
                                <Checkbox name="isWsProject" inputId="isWsProject" v-model="model.isWsProject" binary />
                                <label for="isWsProject">{{ $t('lang.cluster.create_ws_project')  }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox name="isSerpProject" inputId="isSerpProject" v-model="model.isSerpProject" binary />
                                <label for="isSerpProject">{{ $t('lang.cluster.create_serp_project')  }}</label>
                            </div>
                        </div>
                        <template v-if="model.isWsProject">
                            <div class="field mb-0">
                                <label class="required">{{ $t('lang.cluster.label_frequency') }}</label>
                                <div class="formgroup-inline">
                                    <div class="field-checkbox">
                                        <Checkbox
                                            v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WS]"
                                            binary
                                            inputId="frequency-ws"
                                        />
                                        <label for="frequency-ws">{{ $t('lang.cluster.frequency_ws') }}</label>
                                    </div>
                                    <div class="field-checkbox">
                                        <Checkbox
                                            v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WSK]"
                                            binary
                                            inputId="frequency-wsk"
                                        />
                                        <label for="frequency-wsk">{{ $t('lang.cluster.frequency_wsk') }}</label>
                                    </div>
                                    <div class="field-checkbox">
                                        <Checkbox
                                            v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_SWSK]"
                                            binary
                                            inputId="frequency-swsk"
                                        />
                                        <label for="frequency-swsk">{{ $t('lang.cluster.frequency_swsk') }}</label>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <span class="block text-xs mb-4" v-html="getLimitsUpdateHtml" />
                    </template>
                </div>
                <div class="formgroup-inline">
                    <label>{{ $t('lang.cluster.top_number') }}</label>
                    <div class="field-radiobutton">
                        <RadioButton
                            v-model="model.topNumber"
                            inputId="top10"
                            name="topNumber"
                            :value="10"
                        />
                        <label for="top10">{{ $t('lang.cluster.top10') }}</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton
                            v-model="model.topNumber"
                            inputId="top20"
                            name="topNumber"
                            :value="20"
                        />
                        <label for="top20">{{ $t('lang.cluster.top20') }}</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton
                            v-model="model.topNumber"
                            inputId="top50"
                            name="topNumber"
                            :value="50"
                        />
                        <label for="top50">{{ $t('lang.cluster.top50') }}</label>
                    </div>
                </div>
                <div class="grid grid-nogutter mb-5">
                    <div class="col-4"><label class="inline-block w-full">{{$t('lang.cluster.more_gen_group')}}</label></div>
                    <div class="col-4"><label class="inline-block w-full text-center">{{model.fStrength}} %</label></div>
                    <div class="col-4"><label class="inline-block w-full text-right">{{$t('lang.cluster.more_small_group')}}</label></div>
                    <div class="col-12 mt-1"><Slider v-model="model.fStrength" :min="20" :max="90" :step="10" /></div>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.fIsWsk" inputId="fIsWsk" binary />
                    <label for="fIsWsk">{{ $t('lang.cluster.min_ws_main_key_' + reportEngine) }}</label>
                </div>
                <div class="field">
                    <InputNumber v-model.number="model.fWsk" :min="0" :disabled="!model.fIsWsk" />
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.fIsSumWsk" inputId="fIsSumWsk" binary />
                    <label for="fIsSumWsk">{{ $t('lang.cluster.min_summ_group_' + reportEngine) }}</label>
                </div>
                <div class="field">
                    <InputNumber v-model.number="model.fSumWsk" :min="0" :disabled="!model.fIsSumWsk" />
                </div>
                <AdaptersMessage v-if="isNeedAttention" severity="warn" :message="$t('lang.cluster.attention_before_run')" />
            </template>
        </AdaptersDialog>
    </div>
</template>
<style scoped>
/* иконка-подсказка должна оставаться доступной для наведения, даже когда сам radio задизейблен (.p-disabled * блокирует pointer-events глобально) */
.update-unknown-help {
    pointer-events: auto;
}
</style>
<style>
/*
    Не scoped: тултип PrimeVue рендерит отдельным div'ом в document.body, вне дерева компонента,
    поэтому scoped-стиль до него не достаёт. Правило точечное — только по уникальному id этого тултипа,
    чтобы не влиять на остальные .p-tooltip в проекте.
    Маска модального окна принудительно закреплена на z-index: 100000 !important
    (www/c/themes/custom.css, правило ".p-dialog-mask.p-component-overlay"), поэтому тултипу
    внутри диалога нужен z-index выше этого значения.
*/
#ks-auto-cluster-unknown-tooltip {
    z-index: 100001 !important;
}
</style>
